import { IHocPhanMienInsertsRequest } from "../../../model/request/diem/hoc-phan-mien/IHocPhanMienInsertsRequest";
import { apiClient } from "../../apiClient";

const HOC_PHAN_MIEN_ENDPOINT = 'hoc-phan-mien';
export const hocPhanMienApi = {
    SelectByLop: (id_lops: number[]) => apiClient.post(`${HOC_PHAN_MIEN_ENDPOINT}/select-by-lops`, id_lops),
    Inserts: (data: IHocPhanMienInsertsRequest) => apiClient.post(`${HOC_PHAN_MIEN_ENDPOINT}/inserts`, data),
    Deletes: (id_mon_miens: number[]) => apiClient.post(`${HOC_PHAN_MIEN_ENDPOINT}/deletes`, id_mon_miens),
}